<template>
  <div class="inscr-root">
    <AppHeader />
    <div class="inscr-content">
      <div class="inscr-page-header">
        <span class="inscr-badge">📝 Inscribir</span>
        <h1 class="inscr-title">Formulario de Inscripción</h1>
        <p class="inscr-subtitle">Inscribí nuevos cargadores en la procesión seleccionada</p>
      </div>

      <v-overlay :value="loading" color="var(--sys-bg)" opacity="0.9">
        <div class="inscr-loading">
          <div class="inscr-spinner"></div>
          <span>Cargando...</span>
        </div>
      </v-overlay>

      <div class="inscr-table-wrap">
        <AppTable :cargadores="Listacargadores" ref="tableComponent" />
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from "@/components/HeaderC.vue";
import AppTable from "@/components/TableInscribir.vue";
import axios from "axios";

export default {
  name: "InscripcionesView",
  data() {
    return {
      Listacargadores: [],
      loading: false,
      validToken: false,
    };
  },
  components: {
    AppHeader,
    AppTable,
  },
  mounted: function () {
    this.obtieneRegistros();
  },
  methods: {
    validateToken() {
      // const token = localStorage.token
      const token = this.$cookies.get("token");
      this.loading = true;
      const apiUrl = `https://wm1xvvtarj.execute-api.us-east-1.amazonaws.com/dev/validateToken?token=${token}`;
      this.loading = true;
      // const apiUrl = `https://wm1xvvtarj.execute-api.us-east-1.amazonaws.com/dev/validateToken?token=${token}`;
      // Configuración para la solicitud GET con el token en el encabezado Authorization

      // Realizar solicitud GET a la API original con el token en el encabezado
      return axios
        .get(apiUrl)
        .then((response) => {
          const username = response.data.decoded.username;
          this.$cookies.set("username", username, "1d", "", "", true, "Strict");
          // localStorage.username = response.data.decoded.username;
          this.validToken = true;
          this.loading = false; // Desactivar animación de carga
        })
        .catch(() => {
          this.validToken = false;
          // console.error(error)
          //  console.error('Error al obtener datos de la API', error);
          this.loading = false; // Desactivar animación de carga en caso de error
        });
    },
    clearAllCookies() {
      const allCookies = this.$cookies.keys();
      for (const cookie of allCookies) {
        this.$cookies.remove(cookie);
      }
    },
    async obtieneRegistros() {
      await this.validateToken();
      if (!this.validToken) {
        // localStorage.clear
        this.clearAllCookies();
        // this.$router.push('/');
        return;
      }
      const apiUrl = `https://wj7gxic747.execute-api.us-east-1.amazonaws.com/dev/api/inscripciones?usr=${this.$cookies.get("username")}&idpro=${this.$cookies.get("ProcesionID")}`;
      //   const apiUrl = `https://62jecp6v6f.execute-api.us-east-1.amazonaws.com/dev/api/cargadores?usuarioResponsable=${this.$cookies.get("username")}`;
      const token = this.$cookies.get("token");
      // Configuración para la solicitud GET con el token en el encabezado Authorization
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      this.loading = true; // Activar animación de carga
      // Realizar solicitud GET a la API original con el token en el encabezado
      axios
        .get(apiUrl, config)
        .then((response) => {
          this.Listacargadores = response.data.records[0];

          this.loading = false; // Desactivar animación de carga
        })
        .catch(() => {
          // console.error('Error al obtener datos de la API', error);
          this.loading = false; // Desactivar animación de carga en caso de error
        });
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');

.inscr-root {
  font-family: 'Inter', sans-serif;
  min-height: 100vh;
  background: var(--sys-bg);
}
.inscr-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 90px 32px 60px;
}
.inscr-loading {
  display: flex; flex-direction: column; align-items: center; gap: 14px;
  color: var(--sys-text-secondary); font-size: 0.9rem;
}
.inscr-spinner {
  width: 36px; height: 36px;
  border: 3px solid rgba(123,47,247,0.3);
  border-top-color: #7b2ff7;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }

.inscr-page-header { margin-bottom: 32px; }
.inscr-badge {
  display: inline-block;
  background: rgba(123,47,247,0.15);
  border: 1px solid rgba(123,47,247,0.35);
  color: #c4a0ff;
  padding: 5px 14px;
  border-radius: 100px;
  font-size: 0.78rem;
  font-weight: 600;
  margin-bottom: 12px;
  letter-spacing: 0.03em;
}
.inscr-title {
  font-size: clamp(1.6rem, 3vw, 2.2rem);
  font-weight: 800;
  color: var(--sys-text-primary);
  margin-bottom: 6px;
}
.inscr-subtitle {
  color: var(--sys-text-secondary);
  font-size: 0.95rem;
  margin: 0;
}
.inscr-table-wrap {
  background: var(--sys-card-bg);
  border: 1px solid var(--sys-card-border);
  border-radius: 18px;
  padding: 8px;
  backdrop-filter: blur(12px);
  overflow: hidden;
}
::v-deep .v-data-table { background: transparent !important; }
::v-deep .v-data-table .v-data-table__wrapper table { background: transparent !important; }
[data-theme="dark"] ::v-deep .v-data-table thead tr th {
  background: rgba(123,47,247,0.12) !important;
  color: rgba(255,255,255,0.7) !important;
}
::v-deep .v-data-table thead tr th {
  background: var(--sys-table-header) !important;
  color: var(--sys-text-secondary) !important;
  font-family: 'Inter', sans-serif !important;
  font-weight: 600 !important;
  font-size: 0.78rem !important;
  text-transform: uppercase !important;
  letter-spacing: 0.05em !important;
  border-bottom: 1px solid var(--sys-card-border) !important;
}
::v-deep .v-data-table tbody tr { background: transparent !important; transition: background 0.2s !important; }
::v-deep .v-data-table tbody tr:hover { background: var(--sys-table-row-hover) !important; }
::v-deep .v-data-table tbody tr td {
  color: var(--sys-text-primary) !important;
  font-family: 'Inter', sans-serif !important;
  font-size: 0.88rem !important;
  border-bottom: 1px solid var(--sys-card-border) !important;
}
::v-deep .v-data-footer {
  background: transparent !important;
  border-top: 1px solid var(--sys-card-border) !important;
  color: var(--sys-text-secondary) !important;
}
::v-deep .v-data-footer .v-select__selection {
  color: var(--sys-text-primary) !important;
}
@media (max-width: 768px) {
  .inscr-content { padding: 80px 16px 40px; }
}
</style>
